import { createRouter, createWebHashHistory } from 'vue-router'

// import store from '../store'

const routes = [
  {
    path: '/',
    name: 'Environment',
    component: () => import('../views/Environment.vue'),
    props: true
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes
})

export default router
